import { Component, ViewChild } from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Clipboard } from '@angular/cdk/clipboard';
import { ConfigurationService } from '@services/configuration.service';
import { TokenService } from '@services/token.service';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { BankTransferConfirmDialogComponent } from './bank-transfer-confirm-dialog.component';

@Component({
  selector: 'app-sidebar-bank-transfer',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatSidenav,
    MatIconModule,
    MatButtonModule,
    MatSnackBarModule,
    MatDialogModule,
  ],
  templateUrl: './sidebar-bank-transfer.component.html',
  styleUrl: './sidebar-bank-transfer.component.css'
})
export class SidebarBankTransferComponent {
  @ViewChild(MatSidenav) sidenav!: MatSidenav;

  alias: string = '';
  titular: string = '';
  cuilCuit: string = '';
  banco: string = '';
  isLoading: boolean = true;

  constructor(
    private configService: ConfigurationService,
    private tokenService: TokenService,
    private clipboard: Clipboard,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.watchAuthStatus();
    this.loadBankTransferData();
  }

  open() {
    this.sidenav.open();
  }

  close() {
    this.sidenav.close();
  }

  copyToClipboard(value: string, label: string) {
    this.clipboard.copy(value);
    this.snackBar.open(`${label} copiado al portapapeles`, 'OK', {
      duration: 2000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }

  onTransferDone() {
    const dialogRef = this.dialog.open(BankTransferConfirmDialogComponent, {
      width: '400px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.sidenav.close();
    });
  }

  loadBankTransferData() {
    if (!this.tokenService.isAuthenticated.value) {
      return;
    }
    this.configService.getConfiguration().subscribe({
      next: (response) => {
        this.alias = response.find((r) => r.key == 'bankTransferAlias')?.value || 'quinapp.misiones';
        this.titular = response.find((r) => r.key == 'bankTransferTitular')?.value || 'Instituto Provincial de Loteria y Casino';
        this.cuilCuit = response.find((r) => r.key == 'bankTransferCuilCuit')?.value || '33-61542835-9';
        this.banco = response.find((r) => r.key == 'bankTransferBanco')?.value || 'Banco Macro';
        this.isLoading = false;
      },
      error: () => {
        this.alias = 'quinapp.misiones';
        this.titular = 'Instituto Provincial de Loteria y Casino';
        this.cuilCuit = '33-61542835-9';
        this.banco = 'Banco Macro';
        this.isLoading = false;
      }
    });
  }

  watchAuthStatus() {
    this.tokenService.isAuthenticated.subscribe({
      next: () => {
        this.loadBankTransferData();
      }
    });
  }
}
